import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=136b6b8e&scoped=true&"
import script from "./CarrierList.vue?vue&type=script&lang=js&"
export * from "./CarrierList.vue?vue&type=script&lang=js&"
import style0 from "./CarrierList.vue?vue&type=style&index=0&id=136b6b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b6b8e",
  null
  
)

export default component.exports